import { render } from "./ButtonAddFider.vue?vue&type=template&id=5162ac09&lang=true"
import script from "./ButtonAddFider.vue?vue&type=script&lang=js"
export * from "./ButtonAddFider.vue?vue&type=script&lang=js"

import "./ButtonAddFider.vue?vue&type=style&index=0&id=5162ac09&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__